import { Text } from "atoms";
import { useOpenCallSubmissions } from "../api/useOpenCallSubmissions";

type SubmissionHistoryProps = {
  createdByUserId: string;
};
function AdminSubmissionHistory({ createdByUserId }: SubmissionHistoryProps) {
  const { data } = useOpenCallSubmissions({
    createdByUserId,
    includeFullObject: true,
  });
  const submissions = data?.pages?.flatMap((page) => page.data) ?? [];
  const winningSubmissions = submissions.filter((s) => s.selectedAt);
  return (
    <>
      <Text size="xxxs" bold>
        {submissions.length} Total Submissions
      </Text>
      <Text size="xxxs" bold>
        {winningSubmissions.length} Winning Selections
      </Text>
      <ul>
        {winningSubmissions.map((s) => (
          <li key={s.id}>
            <Text size="xxxs">{s.id}</Text>
          </li>
        ))}
      </ul>
    </>
  );
}

export { AdminSubmissionHistory };
